import { type PlayerFixtureStatistics } from "@prisma/client";
import { YOUTH_TEAM_REGEX } from "../../data-sync/constants";
import { type PlayerResult } from "../routes/latest";

type Player = {
  firstname: string;
  lastname: string;
  fullname: string;
};

export function formatPlayerName(player: Player) {
  return player.fullname || `${player.firstname} ${player.lastname}`;
}

export function getFixtureStatsForPlayer(
  playerId: number,
  fixtureStats: Array<PlayerFixtureStatistics>,
) {
  for (const stats of fixtureStats) {
    if (stats.playerId === playerId) {
      return stats;
    }
  }
  return null;
}

export function abbrName(name: string) {
  const tokens = name.split(" ");
  if (tokens.length === 1) {
    return name;
  }
  const [first, ...rest] = tokens;
  return `${first?.[0]}. ${rest.join(" ")}`;
}

export function getCurrentSquad(player: Pick<PlayerResult, "SquadPlayer">) {
  player.SquadPlayer.sort((a, b) => {
    if (b.createdAt < a.createdAt) {
      return -1;
    }
    return 1;
  });
  for (const squadPlayer of player.SquadPlayer) {
    // Skip youth teams if we can
    if (YOUTH_TEAM_REGEX.test(squadPlayer.team.name)) {
      continue;
    }
    return squadPlayer;
  }

  return player.SquadPlayer[0];
}
